<template>
  <div class="index">
    <div class="hope-container">
      <div class="hope-box">
        <div class="hope-title">
          <img :src="`${require('@assets/images/dywfl/hope-title1.png')}`" alt="">
        </div>

        <!-- <div class="hope-name">想要一些课外书</div> -->
        <div class="hope-intro" v-html="info.content"></div>
      </div>
      <div class="hope-box">
        <div class="hope-title">
          <img :src="`${require('@assets/images/dywfl/hope-title2.png')}`" alt="">
        </div>

        <div class="hope-info">
          <div class="hope-info-item">
            <div class="info-name">许愿人</div>
            <div class="info-msg">
              <img :src="`${require('@assets/images/dywfl/hope-head.png')}`" alt="">
              {{ info.nickname }}
            </div>
          </div>
          <div class="hope-info-item">
            <div class="info-name">联系方式</div>
            <div class="info-msg">{{ info.phone }}</div>
          </div>
          <div class="hope-info-item">
            <div class="info-name">发布时间</div>
            <div class="info-msg">{{ info.add_time }}</div>
          </div>
          <div class="hope-info-item">
            <div class="info-name">详细地址</div>
            <div class="info-msg">{{ info.address }}</div>
          </div>
        </div>

        <img class="left-line" :src="`${require('@assets/images/dywfl/hope-line.png')}`" alt="">
        <img class="right-line" :src="`${require('@assets/images/dywfl/hope-line.png')}`" alt="">
      </div>
    </div>
    <Leader @confirmCheck="confirmCheck" @cancelCheck="cancelCheck"></Leader>
	<Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
.hope-box .hope-intro p {
  font-size: 0.32rem !important;
}

.hope-box .hope-intro img {
  width: 100%;
  display: block;
}
</style>
<script>
import { getWishDetail,Examine } from "@api/public";
import Leader from "@/components/Leader.vue";
import Loading from "@components/Loading";
export default {
  name: "CateList",
  components: {
    Leader,
	Loading
  },
  props: {},
  data: function () {
    return {
      id: 0,
      info: {},
	  loaded: false,
	  loading: false,
    };
  },
  watch: {

  },
  mounted: function () {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    confirmCheck() {
		 this.$dialog.loading.open("正在加载中");
		 let data={};
		   data.id = this.id;
		   data.nav = 1;
		   data.is_leader_check_status=1;
		 Examine(data).then(res => {
			this.$dialog.loading.close();
			this.$dialog.success(res.msg);
			setTimeout(() => {
			  this.$router.go(-1)
			}, 1000);
		 }).catch(res=>{
			this.$dialog.loading.close();
			this.$dialog.error(res.msg);
		 });
    },
  cancelCheck(e){//主席审核失败
    this.$dialog.loading.open("正在加载中");
    let data={};
      data.id = this.id;
      data.nav = 1;
      data.is_leader_check_status=2;
      data.leader_check_fail_remarks=e;
    Examine(data).then(res => {
    	this.$dialog.loading.close();
    	this.$dialog.success(res.msg);
    	setTimeout(() => {
    	  this.$router.go(-1)
    	}, 1000);
    }).catch(res=>{
    	this.$dialog.loading.close();
    	this.$dialog.error(res.msg);
    });
  },
    getDetail() {
      getWishDetail(this.id).then(res => {
        this.info = res.data
      });
    },
    goPage(url) {
      this.$router.push({ path: url });
    }
  },
};
</script>
<style lang="scss" scoped>
.index {
  background-color: #FFE2E7;
  min-height: 100vh;
}

.hope-container {
  background-color: #FE898F;
  padding: .4rem .2rem .2rem;
  margin-top: .5rem;
  border-radius: .3rem;

  .hope-box {
    padding: 0 .5rem 0;
    background-color: #fff;
    border-radius: .2rem;
    position: relative;

    &~.hope-box {
      margin-top: .2rem;
    }

    .hope-title {
      text-align: center;

      img {
        width: 3.97rem;
        height: .76rem;
      }
    }

    .hope-name {
      font-size: .35rem;
      font-weight: bold;
      margin-top: .45rem;
    }

    .hope-intro {
      margin-top: .33rem;
      padding-bottom: 1rem;
      font-size: .28rem;
    }

    .left-line,
    .right-line {
      position: absolute;
      width: .13rem;
      height: .6rem;
      top: 0;
      transform: translateY(-65%);
    }

    .left-line {
      left: .5rem;
    }

    .right-line {
      right: .5rem;
    }
  }
}

.hope-info {
  min-height: 2.7rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: .3rem;
  padding-bottom: .4rem;
}

.hope-info-item {
  display: flex;
  align-items: center;

  .info-name {
    font-size: .28rem;
    color: #5A5A5A;
    min-width: 1.12rem;
    margin-right: .3rem;
  }

  .info-msg {
    display: flex;
    align-items: center;
    font-size: .28rem;

    img {
      width: .5rem;
      height: .5rem;
      margin-right: .2rem;
    }
  }

}

.submit-btn {
  line-height: 1rem;
  margin: .5rem .4rem 0;
  background-image: linear-gradient(180deg, #FD9F81, #F77C75);
  text-align: center;
  color: #fff;
  border-radius: 1rem;
  font-size: .3rem;
}
</style>
